<template>
  <v-dialog v-model="dialog" persistent max-width="400">
    <template v-slot:activator="{ on: dialog1 }">
      <v-col cols="12" class="px-6 py-3">
        <span class="profile-delete" v-on="{ ...dialog1 }">Delete Account</span>
      </v-col>
    </template>
    <v-card>
      <v-card-title class="card-title">
        Delete Account
      </v-card-title>
      <v-card-text>
        Are you sure want to
        <strong>DELETE</strong> Account?
      </v-card-text>
      <v-card-text class="account-delete-info">
        Information: If you would like to reactivate / restore your account
        contact admin for further assistance.
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn color="red darken-1" text @click="disAgree">
          Disagree
        </v-btn>
        <v-btn color="green darken-1" text @click="agree">
          Agree
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { UserService } from "@/services";
import { mapGetters } from "vuex";

export default {
  name: "DeleteAccount",
  data() {
    return {
      dialog: false
    };
  },
  computed: {
    ...mapGetters("user", {
      user: "user"
    })
  },
  methods: {
    async agree() {
      this.dialog = false;
      try {
        const userObj = { isDelete: true };
        const response = await UserService.updateUser({
          id: this.user._id,
          object: userObj
        });
        if (response) {
          this.$store.dispatch(
            "user/setSnack",
            "User account deleted successfully"
          );
          this.$store.dispatch("user/setType", "info");
          this.$store.dispatch("user/setBooking", null);
          this.$store.dispatch("user/setToken", null);
          this.$store.dispatch("user/setUser", null);
          this.$router.push("/");
        }
      } catch (error) {
        this.$store.dispatch("user/setSnack", error);
        this.$store.dispatch("user/setType", "error");
      }
    },
    disAgree() {
      this.dialog = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.profile-delete {
  font-weight: 500;
  font-size: 16px;
  letter-spacing: 0.75px;
  color: #ef4444;
  cursor: pointer;
}
.account-delete-info {
  font-weight: 500;
  color: #f78600 !important;
}
.card-title {
  font-family: "Now Alt";
  font-size: 18px;
  color: #313131;
}
</style>
